var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50196 8.16669C4.52351 6.87305 4.72175 6.30847 5.01794 6.01561C5.33492 5.70221 5.96484 5.5 7.45 5.5H16.7083C18.198 5.5 18.8302 5.70229 19.1482 6.01611C19.4448 6.30888 19.6432 6.87304 19.6647 8.16669H4.50196ZM3 8.91669V8.40833C3 6.94966 3.16691 5.7364 3.96331 4.94897C4.75675 4.16446 5.97683 4 7.45 4H16.7083C18.1853 4 19.4073 4.16438 20.2018 4.94847C20.9998 5.736 21.1667 6.94973 21.1667 8.40833V8.91669V15.25C21.1667 16.7087 20.9998 17.9219 20.2034 18.7094C19.4099 19.4939 18.1898 19.6583 16.7167 19.6583H7.45109C5.97848 19.6624 4.75793 19.5008 3.96381 18.7172C3.16677 17.9306 3 16.7166 3 15.2583V8.91669ZM19.6667 9.66669V15.25C19.6667 16.7163 19.4627 17.3322 19.1487 17.6427C18.8317 17.9561 18.2018 18.1583 16.7167 18.1583L7.45 18.1583L7.44789 18.1583C5.96262 18.1625 5.33356 17.9615 5.01744 17.6495C4.70406 17.3402 4.5 16.725 4.5 15.2583V9.66669H19.6667ZM7.08337 14.8334C6.66916 14.8334 6.33337 15.1692 6.33337 15.5834C6.33337 15.9976 6.66916 16.3334 7.08337 16.3334H8.75004C9.16425 16.3334 9.50004 15.9976 9.50004 15.5834C9.50004 15.1692 9.16425 14.8334 8.75004 14.8334H7.08337ZM10.0834 15.5834C10.0834 15.1692 10.4192 14.8334 10.8334 14.8334H14.1667C14.5809 14.8334 14.9167 15.1692 14.9167 15.5834C14.9167 15.9976 14.5809 16.3334 14.1667 16.3334H10.8334C10.4192 16.3334 10.0834 15.9976 10.0834 15.5834Z",
    fill: "#7956D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.e6467fcacea4676444cfb6130270816a.svg";
export { ForwardRef as ReactComponent };